import React from 'react';
import { XCircle } from 'lucide-react';
const pains = ['Llegás a clase sin saber qué ejercicio dar', 'Tus alumnos no progresan', 'Grupos mezclados = caos', 'Repetís siempre lo mismo', 'No podés cobrar más', 'Improvisás correcciones', 'Perdés horas planificando', 'Sabés que podrías hacerlo mejor… pero no tenés sistema'];
export function PainPoints() {
  return <section className="py-20 px-4 bg-[#0A1628]" data-id="element-237">
      <div className="max-w-4xl mx-auto" data-id="element-238">
        <h2 className="text-3xl md:text-5xl font-anton text-center mb-12 text-white" data-id="element-239">
          Si sos profesor de pádel…{' '}
          <span className="text-red-500" data-id="element-240">esto te está pasando:</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-16" data-id="element-241">
          {pains.map((pain, index) => <div key={index} className="flex items-center gap-4 bg-[#0F1F3D] p-4 rounded-lg border border-red-500/20" data-id="element-242">
              <div className="text-red-500 font-anton text-2xl opacity-50 w-8" data-id="element-243">
                {String(index + 1).padStart(2, '0')}
              </div>
              <XCircle className="text-red-500 shrink-0" size={24} data-id="element-244" />
              <p className="text-gray-300 font-medium" data-id="element-245">{pain}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-246">
          <h3 className="text-4xl md:text-5xl font-anton text-white mb-8" data-id="element-247">
            ¿Cuántas clases más vas a improvisar?
          </h3>
        </div>
      </div>
    </section>;
}